import PropTypes from "prop-types";

const ErrorState = ({ error }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: "#F9FAFC" }}>
      <div
        className="bg-white rounded-2xl p-8 max-w-md w-full text-center"
        style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
      >
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-8 h-8 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold mb-2" style={{ color: "#3B3B3B" }}>
          Payment Link Error
        </h2>
        <p className="mb-6" style={{ color: "#515164" }}>
          {error}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="w-full text-white font-medium py-3 px-6 rounded-lg transition-colors"
          style={{ backgroundColor: "#01793B" }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#015c2e")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#01793B")}
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

ErrorState.propTypes = {
  error: PropTypes.string.isRequired,
};

export default ErrorState;
